import { palette } from './palette';

export const theme = {
  background: palette.space.deep,
  fog: {
    color: palette.space.mid,
    near: 6000,
    far: 34000
  },
  lighting: {
    ambient: { color: palette.light.ambient, intensity: 0.45 },
    key: {
      color: palette.light.key,
      intensity: 1.2,
      position: { x: 140, y: 190, z: 70 }
    },
    rim: {
      color: palette.light.rim,
      intensity: 0.5,
      position: { x: -110, y: 60, z: -170 }
    },
    fill: {
      color: palette.light.fillWarm,
      intensity: 0.22,
      position: { x: 50, y: -80, z: 100 }
    }
  },
  toneMapping: {
    exposure: 1.18
  },
  bloom: {
    enabled: true,
    strength: 0.34,
    radius: 0.82,
    threshold: 0.7
  }
} as const;
